class FormValidator {
  constructor(rules) {
    this.rules = rules;
  }

  validate(state) {
    // start out assuming valid
    const validation = this.valid();

    this.rules.forEach((rule) => {
      if (!validation[rule.field].isInvalid) {
        // determine the field value, the method to invoke and optional args from the rule definition
        const fieldValue = state[rule.field].toString();
        const args = rule.args || [];
        const { method: validationMethod } = rule;

        // call the validationMethod with the current field value as the first argument, any additional arguments, and the
        // whole state as a final argument.  If the result doesn't match the rule.validWhen property, then modify the
        // validation object for the field and set the isValid field to false
        if (validationMethod(fieldValue, ...args, state) !== rule.validWhen) {
          validation[rule.field] = {
            isInvalid: true,
            message: rule.message,
          };
          validation.isValid = false;
        }
      }
    });
    return validation;
  }

  // create a validation object for a valid form
  valid() {
    const validation = {};

    this.rules.map((rule) => {
      validation[rule.field] = { isInvalid: false, message: '' };
      return false;
    });

    return { isValid: true, ...validation };
  }
}

export default FormValidator;